import { useUser } from '~/@biz_account/useUser/useUser'

const FEE_IMMUNITY_VALID_DEADLINE = '2026-07-01T00:00:00+02:00'

export const FEE_IMMUNITY_MIN_INVESTMENT_AMOUNT = 1000

export function useFeeImmunity() {
  const { user } = useUser()

  const validDeadline = new Date(FEE_IMMUNITY_VALID_DEADLINE)
  const now = new Date()

  const hasFeeImmunity = user?.hasRevenueFeeImmunity ?? false

  const showFeeImmunityLink = hasFeeImmunity || now < validDeadline
  const showFeeImmunityPromo = !hasFeeImmunity && now < validDeadline

  return {
    hasFeeImmunity,
    showFeeImmunityPromo,
    showFeeImmunityLink,
  }
}
